let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k05kV")).then(() => parcelRequire('hO1ce'));